import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
import { useDrop } from 'react-dnd';
import { dndConstants } from 'store/constants/dnd.constants';
import { useDispatch } from 'react-redux';
import {
  commonPagesActions,
  fileSelectedActions,
} from 'store/actions';

interface CommonOrSplitBoxProps {
  dndItemType: string;
  title: string;
  description?: string;
  descriptionTexts: { text: string; highlighted?: boolean }[];
}

const CommonOrSplitBox: React.FC<CommonOrSplitBoxProps> = ({
  dndItemType,
  title,
  description,
  descriptionTexts,
}) => {
  const dispatch = useDispatch();
  const [{ isOver }, drop] = useDrop({
    accept:
      dndItemType === dndConstants.COMMON ||
      dndItemType === dndConstants.GLOBAL_COMMON
        ? [dndConstants.SRC_PAGE, dndConstants.SRC_FILE]
        : dndConstants.SRC_FILE,
    canDrop: (item: any, monitor) => {
      // unprocessed file shouldn't be allowed in the common or split
      if (item.type === dndConstants.SRC_FILE) {
        return item.payload.srcFile.canSelectPage;
      }
      return true;
    },
    drop: (item: any, monitor) => {
      const { payload } = item;
      if (dndItemType === dndConstants.COMMON) {
        // if (item.type === dndConstants.SRC_PAGE) {
        // } else if (item.type === dndConstants.SRC_FILE) {
        // }
        dispatch(
          fileSelectedActions.prependPagesToAllDestFiles(
            payload.srcFile,
            payload.pageNum,
          ),
        );
      } else if (
        dndItemType === dndConstants.SPLIT &&
        item.type === dndConstants.SRC_FILE
      ) {
        console.debug('split src file');
        dispatch(
          fileSelectedActions.splitSrcFileAndAdd(payload.srcFile),
        );
      } else if (dndItemType === dndConstants.GLOBAL_COMMON) {
        dispatch(
          commonPagesActions.addFileOrPage(
            payload.srcFile,
            payload.pageNum,
          ),
        );
      }
    },
    collect: (monitor) => ({
      isOver: !!monitor.isOver() && monitor.canDrop(),
    }),
  });
  useEffect(() => {
    console.debug({
      CommonOrSplitBox: isOver,
      dndItemType,
    });
  }, [isOver, dndItemType]);

  return (
    <SMergeType
      key={title}
      className={`${isOver ? 'is-over' : ''}`}
      ref={drop}
    >
      <SMergeTypeTitle>{title}</SMergeTypeTitle>

      {descriptionTexts ? (
        <SMergeTypeDescTexts>
          {descriptionTexts.map((desc, i) => (
            <SDescText
              key={`${i}-${desc.text}`}
              className={desc.highlighted ? 'highlighted' : ''}
            >
              {desc.text}
            </SDescText>
          ))}
        </SMergeTypeDescTexts>
      ) : (
        <SMergeTypeDesc>{`(${description})`}</SMergeTypeDesc>
      )}
    </SMergeType>
  );
};

export default CommonOrSplitBox;
const SMergeType = styled.div.attrs((props) => ({
  className: props.className,
}))`
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
  &.is-over {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border: 2px dashed ${(props) => props.theme.palette.primary.main};
    background: ${(props) => props.theme.palette.highlight.transPink};
  }
  border-radius: 4px;
  text-align: center;
  padding: 0.5rem 1rem;
`;
const SMergeTypeDesc = styled.div`
  font-size: ${(props) => props.theme.typography.fontSize.body};
`;

const SMergeTypeDescTexts = styled.div`
  font-size: ${(props) => props.theme.typography.fontSize.body};
`;
const SMergeTypeTitle = styled.div`
  font-size: ${(props) => props.theme.typography.fontSize.title};
  line-height: ${(props) => props.theme.typography.lineHeight.title};
  font-weight: ${(props) => props.theme.typography.fontWeight.title};
`;

const SDescText = styled.div.attrs((props) => ({
  className: props.className,
}))`
  display: inline;
  &.highlighted {
    background: ${(props) => props.theme.palette.primary.light};
    padding: 0 5px;
  }
  & + & {
    margin-left: 5px;
  }
`;
